/* app/js/src/components/common/layout-icon/layout-icon.component.scss */
/*# sourceMappingURL=layout-icon.component.css.map */
